<template lang="pug">

	span(:class="{'input-item':!flat}")
		.tb(:class="{'error': error , 'search-input': searchIcon, 'with-remove-x': withRemoveX}")
			label(for="")
				span(v-if="label")
					| {{label}}
				money(v-if="type == 'money'" :value="value" v-bind="moneyFormat" @input="emitInputMoney" @change="emitChange($event)" ref="input")
				input(v-else-if="type == 'password'" type="password" :value="value" @change="emitChange($event)" @input="emitInput($event)" :placeholder="placeholder" autocomplete="new-password" ref="input" :id="id")
				textarea(v-else-if="type == 'textarea'" type="password" :value="value" @change="emitChange($event)" @input="emitInput($event)" :placeholder="placeholder" autocomplete="new-password" ref="input" :id="id")
				input(v-else type="text" :value="value" @change="emitChange($event)" @input="emitInput($event)" :placeholder="placeholder" autocomplete="new-password" ref="input" :id="id")
				span.search-icon
				span.remove-x(v-show="withRemoveX" @click="removeContent")
					.helper
					img(:src="`${$store.state.config.s3ResourceHost}/images/icon-close.svg`" alt="Close")

				span.error(v-if="error")
					| {{errorMessage}}
</template>

<style lang="stylus" scoped>
	@import '~assets/css/variables.styl'

	.tb
		input
			color: sfc-gray-dark
			background transparent
		&.error
			input
				border-bottom-color: chart-red
		&.with-remove-x
			input
				padding-right: 30px
	.search-icon
		display none
	.search-input
		input[type="text"]
			padding-left 20px
		.search-icon
			left: 0!important
			background-image: url('https://web-resources.savingforcollege.com/images/icon-search-gray.svg')
			background-repeat: no-repeat
			left: 0
			background-size: contain
			height: 14px
			width: 14px
			display: block
			position: absolute
			top: 13px
	.remove-x
		vertical-align: middle
		position: absolute
		z-index: 50
		display: block
		height: 100%
		width: 40px
		top: 0
		right: 0
		text-align: center
		img
			width: 12px
			opacity: 0.4
		.helper
			display: inline-block
			height: 100%
			vertical-align: middle

</style>
<script>
import {Money} from 'v-money'
export default {
	props: {
		value:{

		},
		errorMessage:{

		},
		error:{

		},
		type:{

		},
		label:{

		},
		placeholder:{

		},
		searchIcon:{

		},
		flat:{
			default: true
		},
		precision:{
			default: 0
		},
		prefix:{
			default: "$"
		},
		suffix:{
			default: ""
		},
		withRemoveX:{
			default: false
		},
		focused:{
			default: false
		},
		id:{
			default: undefined
		}
	},
	components: {Money},
	mounted() {
		if(this.focused) {
			this.$refs.input.focus()
		}
	},
	data() {
		return {
			vmodel: "",
			moneyFormat:{
				decimal: '.',
				thousands: ',',
				prefix: this.$props.prefix,
				suffix: this.$props.suffix,
				precision: this.$props.precision,
				masked: false /* doesn't work with directive */
			},
			lastValueSent: undefined
		}
	},
	methods: {
		removeContent(){
			this.$emit('input', '')
			this.$refs.input.focus()
		},
		emitChange(event) {
			this.$emit('change', event)
		},
		emitInput(event) {
			this.$emit('input', event.target.value)
		},
		emitInputMoney(value) {
			if(value == this.lastValueSent){
				return
			}else{
				this.$emit('input', value)
				this.lastValueSent = value
			}

		}
	}
}
</script>
